import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "api/baseurl";
import { toast } from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import "react-toastify/dist/ReactToastify.css";
import { InputLabel, Select, MenuItem } from "@mui/material";
import { IconButton } from "@mui/material";
import Chip from "@mui/material/Chip";
import CancelIcon from "@mui/icons-material/Cancel";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
// @mui material components
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import { keyframes } from "@mui/system";

import Card from "@mui/material/Card";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from '@mui/material';

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

function DeviceType() {
  const loginData = JSON.parse(localStorage.getItem("loginData"));
const userid = loginData?.userid;
  const [openModal, setOpenModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedId, setSelectedId] = useState(null);
  const [deviceTypeDetails, setDeviceTypeDetails] = useState({
    devicetype: "",
    adminId:userid
  });
  const [deviceTypesList, setDeviceTypesList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [customerTypes, setCustomerTypes] = useState([]);

  const navigate = useNavigate();
  useEffect(() => {
    const fetchCustomerTypes = async () => {
      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
  
        const response = await axios.get("/api/customertype", {
          headers: { Authorization: `Bearer ${token}` },
        });
  
        if (response.status === 200) {
          const decrypted = decryptBody(response.data, secretKey);
          setCustomerTypes(decrypted);
        }
      } catch (err) {
        console.error("Failed to fetch customer types", err);
      }
    };
  
    fetchCustomerTypes();
  }, []);
  const handleOpenModal = () => setOpenModal(true);

  const handleCloseModal = () => {
    setDeviceTypeDetails({ devicetype: "" }); 
    setOpenModal(false); 
    fetchDeviceTypes();

  }; 
  const handleCloseEditModal = () => {
    setOpenEditModal(false);
    setDeviceTypeDetails({ devicetype: "" });
    setSelectedId(null);
  };
  const handleOpenEditModal = async (id) => {
    setLoading(true);

    try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
      const response = await axios.get(`/api/devicetype/${id}`,{
        headers: { Authorization: `Bearer ${token}` },
    });
    if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        setDeviceTypeDetails(decryptedData); 
        setSelectedId(id);
        setOpenEditModal(true);
      }
    } catch (error) {
      console.error("Error fetching device details:", error);
      toast.error("Failed to fetch device details.");
    } finally {
      setLoading(false); 
    }
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
  
      const encryptedData = encryptBody({ id: selectedId }, secretKey);
  
      const response = await axios.post("/api/devicetype/delete", encryptedData, {
        headers: { "Content-Type": "text/plain", Authorization: `Bearer ${token}` },
      });
  
      if (response.status === 200) {
        const decryptedResponse = decryptBody(response.data, secretKey);
        if (!decryptedResponse || !decryptedResponse.id) {
          throw new Error("Decryption failed or invalid response.");
        }
  
        toast.success(decryptedResponse.message || "Device type deleted successfully!");
  
        setDeleteModal(false); // Ensure you have this state for delete modal
        fetchDeviceTypes();
      }
    } catch (error) {
      toast.error(error.message || "Failed to delete device type.");
    } finally {
      setLoading(false);
    }
  };
  
  
  const handleSubmitEdit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
      const encryptedData = encryptBody({ id: selectedId, devicetype: deviceTypeDetails.devicetype }, secretKey);
      const response = await axios.post("/api/devicetype/update", encryptedData, {
        headers: { "Content-Type": "text/plain", Authorization: `Bearer ${token}` },
      });
      if (response.status === 200) {
        const decryptedResponse = decryptBody(response.data, secretKey);
        if (!decryptedResponse || !decryptedResponse.id) {
            throw new Error("Decryption failed or invalid response.");
        }
        toast.success(decryptedResponse.message || "Device type updated successfully!");

        setOpenEditModal(false);
        fetchDeviceTypes();
      }
    } catch (error) {
      toast.error(error.message || "Failed to update device type.");
    }
  };
    const fetchDeviceTypes = async (pageNumber = 1) => {
      setLoading(true);

      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;

        if (!token) throw new Error("Authentication token not found.");

          const response = await axios.get(`/api/devicetype/by-admin/${userid}`

          ,
           {
          params: { page: Math.max(0, pageNumber - 1) },    
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200) {
          const decryptedData = decryptBody(response.data, secretKey);
          setDeviceTypesList(decryptedData.content || []);
          setCurrentPage(decryptedData.number + 1);
    setTotalPages(decryptedData.totalPages);
        }
      } catch (error) {
        console.error("Error fetching device types:", error);
        // toast.error("Failed to fetch device types.");
      } finally {
        setLoading(false); 
      }
    };

   useEffect(() => {
  fetchDeviceTypes();
}, []);

  const handleInputChange = (e) => {
    setDeviceTypeDetails({ ...deviceTypeDetails, devicetype: e.target.value });
  };
 
  const handleSubmitCreate = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { devicetype} = deviceTypeDetails;

    if (!deviceTypeDetails.devicetype.trim()) {
        toast.error("Device type cannot be empty!");
        return;
    }
    
    try {
      const secretKey = await fetchSecretKey();
  
      const payload = { devicetype ,adminId:userid };
      console.log("Data before encryption:", payload); 
  
      const encryptedData = encryptBody(payload, secretKey);
  
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
  
     
  
      const response = await axios.post("/api/devicetype/create", encryptedData, {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (response.status === 200) {
        const decryptedResponse = decryptBody(response.data, secretKey);
        console.log("Decrypted Response:", decryptedResponse);

       
  
        if (!decryptedResponse || !decryptedResponse.id) {
            throw new Error("Decryption failed or invalid response.");
        }

        toast.success(decryptedResponse.message || "Device type added successfully!");

          setDeviceTypesList((prevList) => [
            ...prevList,
            { devicetype: deviceTypeDetails.devicetype,
             },
          ]);
  
          setDeviceTypeDetails({ devicetype: "" });  // Reset input properly
        handleCloseModal();
    } else {
        throw new Error("Unexpected server response.");
    }
} catch (error) {
    console.error("Error:", error);
    toast.error(error.message || "Failed to add device type.");
  } finally {
    setLoading(false); 
  }
};
const handleOpenDeleteModal = (id) => {
    setSelectedId(id);
    setDeleteModal(true);
  };

  const handlePageChange = (_, pageNumber) => {
    setCurrentPage(pageNumber);
  };
  useEffect(() => {
    if (searchTerm) {
      setCurrentPage(); 
    }
  }, [searchTerm]);
  
  useEffect(() => {
    if (searchTerm) {
      searchData(currentPage); 
    } else {
      fetchDeviceTypes(currentPage);
    }
  }, [searchTerm, currentPage]);
  
  
  const searchData = async (pageNumber = 1) => {
    setLoading(true);
     
      
       console.log("Search term before API call:", searchTerm);
       try {
         setLoading(true);
         const secretKey = await fetchSecretKey();
         const token = JSON.parse(localStorage.getItem("loginData")).token;
     
         const requestBody = encryptBody({ searchTerm: searchTerm }, secretKey);
   
       const response = await axios.post("/api/devicetype/search", requestBody, {
        params: { page: Math.max(0, pageNumber - 1) },      headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        setDeviceTypesList(decryptedData.content || []);
        setCurrentPage(decryptedData.number + 1);
          setTotalPages(decryptedData.totalPages);
      }
    } catch (error) {
      console.error("Error searching devices:", error);
    } finally {
      setLoading(false);
    }
  };
  

 const spinAnimation = keyframes`
   0% { transform: rotate(0deg); }
   100% { transform: rotate(360deg); }
 `;
 const dotPositions = [
   { top: "5%", left: "50%" },
   { top: "20%", left: "80%" },
   { top: "50%", left: "95%" },
   { top: "80%", left: "80%" },
   { top: "95%", left: "50%" },
   { top: "80%", left: "20%" },
   { top: "50%", left: "5%" },
   { top: "20%", left: "20%" },
 ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: 80, 
              height: 80, 
              animation: `${spinAnimation} 1.5s linear infinite`,
            }}
          >
            {dotPositions.map((pos, index) => (
              <Box
                key={index}
                sx={{
                  width: 8, 
                  height: 8, 
                  borderRadius: "50%",
                  backgroundColor:"#2e7faeff",
                  position: "absolute",
                  ...pos,
                }}
              />
            ))}
          </Box>
        </Box>
      )}
<MDBox mt={4} p={3} display="flex" alignItems="center">
  {/* Left: Title */}
  <MDTypography variant="h5" sx={{ flex: 1 }}>
    DeviceType Details
  </MDTypography>
  <MDBox sx={{ flex: 2, display: "flex", justifyContent: "center" }}>
        <MDInput
          label="Search  DeviceType "
          variant="outlined"
          fullWidth
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ maxWidth: "400px" }}
        />
      </MDBox>
      <MDBox sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
      <MDButton variant="gradient"  color="success" onClick={handleOpenModal}>
          Add Device Type
        </MDButton>
      </MDBox>
      </MDBox>


      {/* Device Type Table */}
      <Box display="flex" justifyContent="center" alignItems="center" width="100%">
      
      <MDBox sx={{ overflowX: "auto", width: "100%" }}>
      <MDTypography variant="h6" textAlign="left" sx={{ marginTop: "-50px" }}
                  >
                    Device Type Deatils:
                  </MDTypography>
  <TableContainer
    component={Paper}
    sx={{
      mt: 3,
      border: "1px solid #ddd",
      borderRadius: "8px",
      boxShadow: "2px 4px 10px rgba(0,0,0,0.1)",
      padding: "30px",
      width: "100%",
    }}
  >        
    <Table sx={{ width: "100%", borderCollapse: "collapse" }}>
            
            {/* Table Head */}
            <TableHead>
            <TableRow sx={{                   backgroundColor:"#2e7faeff" }}>
  <TableCell sx={{ fontWeight: "bold", textAlign: "center", width: "500px",border: "1px solid #ddd" }}>
            Device Type
          </TableCell>
  <TableCell sx={{ fontWeight: "bold", textAlign: "center", width: "500px" ,border: "1px solid #ddd"}}>
            Action
          </TableCell>
              </TableRow>
            

            {/* Table Body */}
            <TableBody>
              {deviceTypesList.length > 0 ? (
                deviceTypesList.map((device) => (
                  <TableRow key={device.id} sx={{ "&:nth-of-type(even)": { backgroundColor: "#fafafa" } }}>
              <TableCell sx={{ textAlign: "center",border: "1px solid #ddd" }}>
                {device.devicetype}
              </TableCell>
              <TableCell sx={{ textAlign: "center",border: "1px solid #ddd" }}>
                <IconButton
                  color="default"
                  onClick={() => handleOpenEditModal(device.id)}
                >
                  <EditIcon />
                </IconButton>
                <IconButton
                  color="default"
                  onClick={() => handleOpenDeleteModal(device.id)}
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
                </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={2} align="center" sx={{ border: "1px solid #ddd", padding: "12px", fontStyle: "italic", color: "gray" }}>No Data Available</TableCell>
                </TableRow>
              )}
            </TableBody>
            </TableHead>
            <Box mt={2} display="flex" justifyContent="center">
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            color="success"
            sx={{
              "& .MuiPaginationItem-root": {
                borderRadius: "4px", 
              },
            }}
          />
        </Box>
          </Table>
        </TableContainer>
        
      </MDBox>
      </Box>
      {/* Modal for Adding Device Type */}
      <Modal open={openModal} onClose={handleCloseModal} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Card sx={{ width: "1000px", maxWidth: "600px", padding: 3 }}>
          <MDBox pt={4} pb={3} px={3}>
            <form onSubmit={handleSubmitCreate}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <MDBox mb={2}>
                  <MDInput type="text" label="Device Type" fullWidth value={deviceTypeDetails.devicetype} onChange={(e) => setDeviceTypeDetails({ devicetype: e.target.value })} required />
                

                   
                  </MDBox>
                </Grid>
              </Grid>

              <MDBox mt={3} textAlign="center">
                <MDButton variant="gradient" color="success" type="submit">Submit</MDButton>&emsp;
                <MDButton variant="outlined" color="secondary" onClick={handleCloseModal}>Cancel</MDButton>
              </MDBox>
            </form>
          </MDBox>
        </Card>
      </Modal>
      <Modal open={openEditModal} onClose={handleCloseEditModal} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Card sx={{ width: "1000px", maxWidth: "600px", padding: 3 }}>
          <MDBox pt={4} pb={3} px={3}>
            <form onSubmit={handleSubmitEdit}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <MDBox mb={2}>
                    <MDInput
                      type="text"
                      label="Device Type"
                      fullWidth
                      value={deviceTypeDetails.devicetype}
                      onChange={handleInputChange}
                      required
                    />
                  </MDBox>
                </Grid>
                
                <Grid item xs={12}>
           
          </Grid>
              </Grid>

              <MDBox mt={3} textAlign="center">
                <MDButton variant="gradient" color="success" type="submit">Update Device Type</MDButton>&emsp;
                <MDButton variant="outlined" color="secondary" onClick={handleCloseEditModal}>Cancel</MDButton>
              </MDBox>
            </form>
          </MDBox>
        </Card>
      </Modal>
      <Modal open={deleteModal} onClose={() => setDeleteModal(false)} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Card sx={{ padding: 3, width: "400px", textAlign: "center" }}>
          <Typography variant="h6" gutterBottom>Are you sure you want to delete this device type?</Typography>
          <MDButton onClick={handleDelete} color="error"  sx={{ minWidth: "60px", marginRight: "5px", padding: "5px 10px" }}>Yes</MDButton>&emsp;
          <MDButton color="secondary" onClick={() => setDeleteModal(false)} sx={{ minWidth: "30px" }}>Cancel</MDButton>
        </Card>
      </Modal>
       
    </DashboardLayout>
  );
}

export default DeviceType;
